<template>
  <div>
    <b-button 
      :disabled="this.document.saldo == 0 || this.document.ctaCteSaldo == 0"
      @click="$bvModal.show(`${index}`)" 
      :variant="this.document.saldo == 0 || this.document.ctaCteSaldo == 0 ? 'success' : 'danger'"
    >
      {{this.estado}}
    </b-button>
    <b-modal :id="`${index}`" size="lg" title="Pagar" hide-footer>
      <div>
        <form
          action="https://hubpagosqa.mitta.cl/WebPayPlus/NormalCreate"
          method="post"
        >
          <b-row>
            <b-col lg="4">
              <b-form-group label="Nombre" label-for="nombre">
                <b-form-input
                  name="nombre"
                  :value="$store.getters['rutEmpresa/cuentaSeleccionada'].text"
                  disabled
                  className="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Orden de Compra" label-for="ordenCompra">
                <b-form-input
                  name="ordenCompra"
                  :value="document.factura_Boleta || document.ctaCteNroDocto"
                  disabled
                  className="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="3">
              <b-form-group label="Monto" label-for="monto">
                <b-form-input
                  name="monto"
                  :value="document.saldo || document.ctaCteSaldo"
                  disabled
                  className="form-control"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div className="row">
            <input type="hidden" name="idCliente" value="5" />

            <input type="hidden" name="documentos" :value="getDocument()" />
            <input
              type="hidden"
              name="urlCallback"
              :value="`${VUE_APP_API_SITE}/detalle_factura/${document.ctaCteNroDocto}?T=${document.evenTipoDoc}&check=true`"
            />
          </div>

          <div className="row">
            <b-button
              type="submit"
              variant="danger"
              @click="$bvModal.hide(`${index}`)"
            >
              Pagar
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    document: Object,
    index: Number,
  },
  data(){
    return {
      VUE_APP_API_SITE: process.env.VUE_APP_API_SITE,
      estado: this.document.saldo == 0 || this.document.ctaCteSaldo == 0 ? "Pagado" : "Pagar"
    }
  },
  methods: {
    getDocument() {
      const documentos = [
        {
          numeroDocumento: this.document.ctaCteNroDocto,
          monto: this.document.saldo,
          fecha: `${moment().format()}Z`,
        }
      ];
      return JSON.stringify(documentos);
    },
  },
};
</script>

<style>
</style>